<div class="flex flex-col">
  <div class="banner-color max-width-lg">
    <div class=" pt-16 pb-64">
      <app-breadcrumb [items]="breadcrumbItems" class="mt-16"></app-breadcrumb>
      <div class="flex flex-row items-center">
        <div class="mat-headline-1 mb-0">{{ 'SETTINGS.SETTINGS' | transloco }}</div>
      </div>
    </div>
  </div>

  <div class="flex max-width-lg">
    <div class="flex flex-row basis-full">
      <div class="left-panel pt-42">
        <app-vertical-menu [menuItems]="verticalMenuItems" (selected)="showEvents($event)"></app-vertical-menu>
      </div>
  
      <div class="basis-full right-panel p-24 right-width" *ngIf="auth">
        <div class="mat-headline-5 mb-14">{{ 'SETTINGS.AUTHENTICATION_MANAGEMENT' | transloco }}</div>
        <mat-divider class="settings-divider mb-10"></mat-divider>
        <app-view-settings-urls *ngIf="keycloakEndpoint || gitlabEndpoint" [endpoint]="keycloakEndpoint"
          [gitlabendpoint]="gitlabEndpoint" [showCopyUrl]="true" (urlCopied)="onCopiedUrl()"></app-view-settings-urls>
      </div>
  
  
      <div class="basis-full right-panel p-24 pt-42 right-width ml-20" *ngIf="profile">
        <div class="mat-headline-5 mb-14">{{ 'SETTINGS.PROFILE' | transloco }}</div>
        <mat-divider class="settings-divider mb-10"></mat-divider>
  
  
        <div class="flex flex-row">
          <mat-icon svgIcon="person" class="user-icon" (click)="closeToast()"></mat-icon>
  
          <div class="flex flex-col w-100-percent mt-40">
  
            <div class="flex justify-between items-center row-content">
              <span class="fw-700 ml-18 mat-headline-5 mb-0 mb-16">{{principal?.attributes?.given_name}}
                {{principal?.attributes?.family_name}}</span>
              <div class="flex items-center mr-16">
              </div>
            </div>
  
  
            <div class="flex flex-col">
              <div class="flex flex-row ml-18">
                <mat-icon svgIcon="inbox" class="mr-8 mt-4 icon-sm"></mat-icon>
                <div class="define-typography-level fw-400 mb-0 mat-body-1 m-0">{{principal?.attributes?.email}}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
  
      <div class="basis-full right-panel p-24 right-width" *ngIf="region">
        <div class="mat-headline-5 mb-14">{{ 'SETTINGS.REGION_MANAGEMENT' | transloco }}</div>
        <mat-divider class="settings-divider mb-10"></mat-divider>
  
  
  
        <div class="table-tr">
          <div appTableRow>
            <div class="region-tr p-20">
              <div class="flex justify-between items-center row-content">
                <div class="flex flex-col">
                  <span class="fw-600 mat-headline-5 mb-10">{{'SETTINGS.PRIMARY_REGION' | transloco}}</span>
                  <span class="fw-400 define-typography-level mb-24">{{'SETTINGS.ALL_SERVICES' | transloco}}</span>
                </div>
  
                <div class="flex items-center mr-16">
                  <span class="copy-url mat-subtitle-2 fw-600">{{'SETTINGS.NO_OF_SERVICES' | transloco}}: {{instancelength}}</span>
                </div>
              </div>
            </div>
  
            <div class="flex justify-between items-center row-content p-20">
              <div class="flex flex-row items-center">
                <mat-icon svgIcon="place" class="icon-sm mr-12"></mat-icon>
                <span class="mat-subtitle-2 m-0 mt-0 fw-600">{{tenantRegion}}</span>
              </div>
            </div>
          </div>
        </div>
  
      </div>
  
    </div>
  </div>
</div>
